import React, { useEffect } from 'react';
import './App.css';
import miamiCoinLogo from './assets/original.png';
import cityOfMiamiLogo from './assets/City Seal_primary_fill_2024.jpg';

function App() {
  useEffect(() => {
    const schema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebSite",
          "name": "MiamiCoin Investments",
          "url": "https://miamicoin.netlify.app",
          "description": "MiamiCoin Investments helps Florida residents explore profitable opportunities in crypto, blockchain, Bitcoin, altcoins, passive income, and long-term wealth strategies.",
          "keywords": [
            "Miami crypto",
            "Florida crypto",
            "crypto investment",
            "best crypto to buy",
            "Bitcoin Miami",
            "Ethereum investment",
            "crypto staking",
            "passive income crypto",
            "best investments Florida",
            "Miami investments",
            "how to invest in crypto",
            "wealth building Florida",
            "side hustles Miami",
            "best business ideas Miami",
            "make money in Florida",
            "how to invest money Miami",
            "blockchain investment",
            "crypto guide Miami",
            "MiamiCoin",
            "Miami cryptocurrency",
            "crypto trading Miami",
            "Florida investors",
            "Miami business opportunities",
            "high yield investments Florida",
            "real estate vs crypto",
            "financial freedom Miami"
          ]
        },
        {
          "@type": "Organization",
          "name": "MiamiCoin Investments",
          "url": "https://miamicoin.netlify.app",
          "logo": "https://miamicoin.netlify.app/logo.png",
          "sameAs": [
            "https://twitter.com/",
            "https://www.facebook.com/",
            "https://www.instagram.com/"
          ],
          "description": "MiamiCoin Investments provides crypto investment education, market insights, blockchain opportunities, and strategic wealth guidance for Florida residents.",
          "foundingLocation": "Miami, Florida"
        },
        {
          "@type": "FinancialService",
          "name": "MiamiCoin Digital Investment Services",
          "url": "https://miamicoin.netlify.app",
          "serviceType": "Crypto and Digital Asset Guidance",
          "areaServed": [
            "Miami",
            "Florida",
            "United States"
          ],
          "description": "Trusted crypto and digital investment educational service offering market strategies for Miami and Florida residents.",
          "offers": {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "USD",
            "description": "Free beginner-friendly guides on crypto investing, wealth building, passive income strategies, and blockchain opportunities."
          }
        },
        {
          "@type": "Product",
          "name": "MiamiCoin Crypto Guide",
          "url": "https://miamicoin.netlify.app",
          "description": "A complete crypto investment guide for Florida residents, teaching how to build wealth using blockchain, Bitcoin, and digital assets.",
          "brand": "MiamiCoin Investments",
          "keywords": [
            "crypto guide",
            "Miami crypto investment",
            "Florida investors",
            "best crypto strategies",
            "crypto for beginners Miami"
          ],
          "offers": {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "USD",
            "availability": "https://schema.org/InStock"
          }
        },
        {
          "@context": "https://schema.org",
          "@type": "VideoObject",
          "name": "Mayor Francis Suarez on The Future of Miami",
          "description": "Watch the Mayor of Miami, Francis Suarez, explain his vision for turning Miami into a global tech and crypto hub.",
          "thumbnailUrl": "https://img.youtube.com/vi/iUia_5nCpuQ/maxresdefault.jpg",
          "uploadDate": "2021-01-26",
          "duration": "PT2M49S",
          "contentUrl": "https://www.youtube.com/watch?v=iUia_5nCpuQ",
          "embedUrl": "https://www.youtube.com/embed/iUia_5nCpuQ",
          "publisher": {
            "@type": "Organization",
            "name": "City of Miami",
            "logo": {
              "@type": "ImageObject",
              "url": "https://miamicoin.netlify.app/logo.png",
              "width": 600,
              "height": 60
            }
          },
          "actor": {
            "@type": "Person",
            "name": "Francis Suarez",
            "jobTitle": "Mayor of Miami",
            "sameAs": "https://en.wikipedia.org/wiki/Francis_X._Suarez"
          },
          "keywords": "MiamiCoin, cryptocurrency, Miami, mayor, blockchain, city initiatives, Francis Suarez",
          "interactionStatistic": {
            "@type": "InteractionCounter",
            "interactionType": "https://schema.org/WatchAction",
            "userInteractionCount": 58000
          }
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <img src={miamiCoinLogo} className="main-logo" alt="MiamiCoin Logo" />
        <h1>MiamiCoin – Invest in the Future of Cities</h1>
        <p className="subtitle">A City-Powered Cryptocurrency</p>
      </header>

      <main className="content-wrapper">
        <section className="intro-section">
          <p>
            MiamiCoin (MIA) is the world’s first city-based cryptocurrency, created to drive innovation, growth, and community impact in Miami while rewarding its supporters worldwide. Built on the Stacks protocol and secured by Bitcoin, MiamiCoin channels revenue directly into Miami’s treasury while providing investors with opportunities for crypto rewards.
          </p>
        </section>

        <section className="why-miami-section golden-ratio-layout">
          <div className="major-column">
            <h2>Why MiamiCoin?</h2>
            <div className="feature">
              <h3>Empowering Miami’s Future</h3>
              <p>Every time MiamiCoin is mined, a portion of the proceeds goes directly to the City of Miami. This revenue funds infrastructure, community programs, and future-forward projects, all without raising taxes.</p>
            </div>
            <div className="feature">
              <h3>Rewards for Investors</h3>
              <p>By stacking MiamiCoin, investors earn a daily reward on investment of upto 10% paid upon withdrawal request via Bitcoin or USDT.</p>
            </div>
            <div className="feature">
              <h3>Led by Visionary Leadership</h3>
              <p>Miami’s Mayor, Francis Suarez, has embraced MiamiCoin as part of his mission to make Miami the crypto capital of the world, creating a bridge between blockchain innovation and real civic progress.</p>
            </div>
          </div>
          <div className="minor-column">
            <div className="video-container">
              <iframe
                src="https://www.youtube.com/embed/iUia_5nCpuQ"
                title="Mayor Francis Suarez on Miami's Future"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <p className="caption">Mayor Francis Suarez on MiamiCoin</p>
          </div>
        </section>

        <section className="investors-crypto-section">
          <h2>Why Miami Investors Are Turning to Crypto in 2025</h2>
          <p>
            Miami has become one of the fastest-growing crypto hubs in the United States — attracting entrepreneurs, digital nomads, and investors from all over the world. As more people move into South Florida, interest in digital assets has exploded, especially among those looking for new ways to grow their money in 2025.
          </p>
          <p>
            If you live in Florida and want to understand why crypto is gaining momentum, here are the biggest reasons Miami investors are diving into digital currencies today.
          </p>

          <div className="feature">
            <h3>1. Miami Is the Crypto Capital of the United States</h3>
            <p>
              Miami is home to blockchain summits, Web3 events, startup incubators, and crypto-focused meetups. Many Latin American and international investors also pass through the city, creating a large community of people already familiar with digital payments and digital wealth.
            </p>
            <p>
              This unique environment makes Miami one of the most active crypto regions in America — and a perfect place for early-stage crypto opportunities.
            </p>
          </div>

          <div className="feature">
            <h3>2. Florida Residents Want Faster Ways to Grow Their Money</h3>
            <p>Search trends from Florida show keyword surges for:</p>
            <ul>
              <li>“best crypto to invest in 2025”</li>
              <li>“Miami investment opportunities”</li>
              <li>“how to make money online fast”</li>
              <li>“crypto passive income”</li>
              <li>“invest with little money”</li>
            </ul>
            <p>These searches tell us one thing: Floridians want simple, fast, online-based investment opportunities.</p>
            <p>Crypto naturally fits this demand because it’s:</p>
            <ul>
              <li>flexible</li>
              <li>decentralized</li>
              <li>easy to start</li>
              <li>available 24/7</li>
              <li>beginner-friendly</li>
            </ul>
          </div>

          <div className="feature">
            <h3>3. Miami’s International Community Already Understands Digital Money</h3>
            <p>
              Miami has a large community of people from Latin America, the Caribbean, Europe, and Africa — many of whom already use digital wallets, mobile payments, and online money transfers.
            </p>
            <p>For them, crypto is not just a trend — it’s practical.</p>
            <p>This global mix makes Miami an ideal environment for new crypto projects to gain traction rapidly.</p>
          </div>

          <div className="feature">
            <h3>4. MiamiCoin Is Becoming One of the Most Watched Local Crypto Projects</h3>
            <p>One of the biggest reasons crypto is gaining attention in South Florida is the rising interest in MiamiCoin (MIA) — a city-based cryptocurrency designed to support local innovation while giving holders long-term potential benefits.</p>
            <h4>✔ A Unique City-Focused Crypto Concept</h4>
            <p>MiamiCoin represents an innovative idea: A cryptocurrency associated with a major U.S. city known for technology, finance, and global tourism. This makes it more recognizable and potentially more stable than random meme tokens.</p>
            <h4>✔ Growing Community and Investor Attention</h4>
            <p>Social media groups, local investors, and crypto communities in Miami continue to increase awareness about MiamiCoin. As adoption grows, so does the long-term interest.</p>
            <h4>✔ Potential Future Utility</h4>
            <p>Investors are excited about MiamiCoin’s future possibilities:</p>
            <ul>
              <li>integration with local businesses</li>
              <li>city events and tourism rewards</li>
              <li>payments for Miami-based services</li>
              <li>staking and earning opportunities</li>
              <li>digital identity or local membership benefits</li>
            </ul>
            <p>As Miami continues to brand itself as a Web3 capital, the value of a Miami-affiliated cryptocurrency becomes much more attractive.</p>
            <h4>✔ Beginner-Friendly Investment</h4>
            <p>MiamiCoin offers an accessible entry point for new investors who want to join the crypto world without needing a large amount of money.</p>
          </div>

          <div className="feature">
            <h3>5. People Want Real Financial Freedom</h3>
            <p>Florida search engine data shows consistent interest in:</p>
            <ul>
              <li>side hustles</li>
              <li>passive income</li>
              <li>crypto investment</li>
              <li>online business</li>
              <li>earning money from home</li>
            </ul>
            <p>Crypto remains one of the easiest and most flexible wealth-building tools available.</p>
            <p>Miami investors recognize this — and that’s why crypto continues to grow in popularity.</p>
          </div>

          <h3>Final Thoughts</h3>
          <p>
            Miami is quickly becoming a global hub for digital innovation and crypto investment. The city’s culture, community, and rapid tech growth make it the perfect environment for evaluating new digital assets — especially Miami-based projects like MiamiCoin.
          </p>
          <p>
            If you’re looking for new ways to invest, explore crypto opportunities, or understand where the digital economy is heading, forget Bitcoin, MiamiCoin is the right place to begin!
          </p>
        </section>

        <section className="opportunity-section">
          <h2>The Opportunity</h2>
          <ul>
            <li>Be part of a pioneering model for city-based cryptocurrencies.</li>
            <li>Earn daily passive income while supporting Miami’s development.</li>
            <li>Help shape the future of crypto-driven civic finance.</li>
            <li>Join a growing community of global investors and innovators.</li>
          </ul>
        </section>

        <section className="cta-section">
          <h2>Join the Movement</h2>
          <p>MiamiCoin isn’t just an investment—it’s a statement. It’s about building a future where cities and citizens thrive together through blockchain-powered innovation.</p>
          <p className="cta-final-line">Invest in Miami. Invest in the future. Invest in MiamiCoin.</p>
          <a href="http://t.me/miamicoin_bot" target="_blank" rel="noopener noreferrer" className="cta-button">
            Get Started Today
          </a>
        </section>
      </main>

      <footer className="App-footer">
        <img src={cityOfMiamiLogo} className="footer-logo" alt="City of Miami Logo" />
        <p>&copy; {new Date().getFullYear()} MiamiCoin. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;